export enum LocalStorageConstants {
  TokenHeader = 'X-Auth-Token',
  Token = 'token',
  CurrentTheme = 'current_theme',
  Authorities = 'authorities',
  Role = 'role',
  UserId = 'user_id',
  UserName = 'user_name',
  Name = 'name',
  Email = 'email',
  StartPage = 'start_page',
  ShowBetaEditorNotice = 'show_beta_editor_notice',
}
